
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartUpdateReview as ObiChartUpdateReviewElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-update-review.js';
 
 
 

 
 export const ObiChartUpdateReview = createComponent({
   react: React,
   tagName: 'obi-chart-update-review',
   elementClass: ObiChartUpdateReviewElement,
   events: {
     
   }
  });
 
 